// extracted by mini-css-extract-plugin
export var downArrow = "_f1-0";
export var infoTooltipIcon = "_f1-3";
export var label = "_f1-1";
export var optionCard = "_f1-4";
export var upArrow = "_f1-2";